import Bulletin from "../../../../pages/platforms/cashier/bulletin";
import { Calender, Scheduler } from "../../../../pages/platforms/hr/dtr";
import {
  Quest,
  Staffs,
} from "../../../../pages/platforms/laboratory/staffManagement";
import { Applicants } from "../../../../pages/platforms/manager/settings";
import { Services, Menus } from "../../../../pages/platforms/accounting";
import { Heads } from "../../../../pages/platforms/hr";
import {
  Contract,
  Membership,
  Outsources,
  Utilities,
  Wellness,
  Referrals,
  // HotlinesPoster,
  Suppliers,
  // Onboarding,
} from "../../../../pages/platforms/cashier";
import PreAnalyticalSetup from "../../../../pages/platforms/laboratory/catalog/preAnalytical";
import AnalyticalSetup from "../../../../pages/platforms/laboratory/catalog/analytical";
import PostAnalyticalSetup from "../../../../pages/platforms/laboratory/catalog/postAnalytical";

import {
  Assurance,
  Controls,
  Temperature,
} from "../../../../pages/platforms/laboratory/management";
import {
  Onboard,
  Tasks,
  Reports,
} from "../../../../pages/platforms/laboratory/diagnostics";
import Sendouts from "../../../../pages/platforms/laboratory/diagnostics/sendouts";
import WorkingArea from "../../../../pages/platforms/laboratory/working-area";
import Machines from "../../../../pages/platforms/serviceEngineer/maintenance/tasks/bodySwitcher/LIS";
import Schedules from "../../../../pages/platforms/laboratory/schedules";
import BrandedProducts from "../../../../pages/platforms/laboratory/catalog/brandedProducts";
import Products from "../../../../pages/platforms/laboratory/catalog/products";
import {
  Chemistry as ChemistryLogbook,
  Hematology as HematologyLogbook,
  Urinalysis as UrinalysisLogbook,
  Fecalysis as FecalysisLogbook,
  Serology as SerologyLogbook,
  Electrolyte as ElectrolyteLogbook,
  Miscellaneous as MiscellaneousLogbook,
} from "../../../../pages/platforms/frontdesk/reports/logbooks";
import PurchaseOrders from "../../../../pages/platforms/laboratory/purchaseOrders";
import {
  Reagents,
  Supplies,
} from "../../../../pages/platforms/laboratory/inventory";
// import ClinicalMicroscopy from "../../../pages/platforms/laboratory/workingArea/clinicalMicroscopy";

// In PH labs, Frontdesk/Phlebotomist do the same bench work as the MLS;
// the only difference is who signs the result (handled by Signatories).
const benchStaff = [
  "Frontdesk",
  "Phlebotomist",
  "Jr. Medical Laboratory Scientist",
  "Medical Laboratory Scientist",
  "Sr. Medical Laboratory Scientist",
  "Chief MLS",
];

const laboratory = [
  {
    name: "Dashboard",
    icon: "tachometer-alt",
    path: "/bulettin",
    title: "News and Updates",
    component: Bulletin,
    allowedFor: benchStaff,
  },
  {
    name: "Schedules",
    icon: "clock",
    path: "/schedules",
    title: "Schedules",
    component: Schedules,
  },
  {
    name: "Diagnostics",
    path: "/laboratory/diagnostics",
    icon: "chart-line",
    title: "Daily Operations: onboarding, task queue, tracking, and sendouts",
    children: [
      {
        name: "Onboarding",
        path: "/onboarding",
        icon: "sign-in-alt",
        title: "Pre-Registered Patients & HMO Approvals",
        component: Onboard,
      },
      {
        name: "Tasks",
        path: "/tasks",
        icon: "tasks",
        title: "Extraction, processing, and encoding of pending tests",
        component: Tasks,
      },
      {
        name: "Tracker",
        path: "/reports",
        icon: "file-alt",
        title: "Monitor the progress and results of diagnostics performed",
        component: Reports,
      },
      {
        name: "Sendout",
        path: "/sendout",
        icon: "truck-loading",
        title: "Sendout Patients to Partner Clinics",
        component: Sendouts,
      },
      {
        name: "Mobile Laboratory ( Quest )",
        path: "/quest",
        icon: "ambulance",
        title: "outside medical team operations.",
        component: Quest,
        allowedFor: benchStaff,
      },
    ],
  },
  {
    name: "Quality Management",
    icon: "tv",
    path: "/diagnostics/quality",
    children: [
      {
        name: "Quality Assurance ( Q A )",
        path: "/external",
        icon: "check-circle",
        title: "Quality Control External",
        component: Assurance,
      },
      {
        name: "Quality Control ( Q C )",
        path: "/internal",
        icon: "balance-scale",
        title: "Quality Control Internal",
        component: Controls,
      },
      {
        name: "Temperature",
        path: "/temperature",
        icon: "thermometer-half",
        component: Temperature,
      },
    ],
  },
  {
    name: "Supply Management",
    path: "/lab/inventory",
    icon: "boxes",
    title: "Manage lab supplies and products",
    allowedFor: [
      "Jr. Medical Laboratory Scientist",
      "Medical Laboratory Scientist",
      "Sr. Medical Laboratory Scientist",
      "Chief MLS",
    ],
    children: [
      {
        name: "Reagents",
        icon: "flask",
        path: "/reagents",
        title: "Reagent stock per batch: total, in use and remaining",
        component: Reagents,
      },
      {
        name: "Supplies",
        icon: "box-open",
        path: "/supplies",
        title: "Medical and general supplies",
        component: Supplies,
      },
      {
        name: "Purchase Orders",
        icon: "cart-plus",
        path: "/purchase-orders",
        title:
          "Request, approve and receive brands; received items become stock",
        component: PurchaseOrders,
      },
      {
        name: "Maintenance Request",
        icon: "tools",
        path: "/maintenance",
        title: "Request machine servicing",
      },
      {
        name: "Consumables",
        icon: "tv",
        path: "/consumables/tagging",
        title: "Categorized consumables for lab",
        children: [
          {
            name: "Preanalytical",
            path: "/preanalytical",
            icon: "check-circle",
            component: PreAnalyticalSetup,
            title: "Items before analysis",
          },
          {
            name: "Analytical",
            path: "/analytical",
            icon: "balance-scale",
            component: AnalyticalSetup,
            title: "Items during analysis",
          },
          {
            name: "Postanalytical",
            path: "/postanalytical",
            icon: "thermometer-half",
            component: PostAnalyticalSetup,
            title: "Items after analysis",
          },
        ],
      },
      {
        name: "Products",
        icon: "cubes",
        path: "/generic-products",
        title:
          "Generic reagents and supplies, and the brands registered for each",
        component: BrandedProducts,
      },
      // {
      //   name: "Branded Products",
      //   icon: "tags",
      //   path: "/branded-products",
      //   title: "Brands of the generic products used by this branch",
      //   component: BrandedProducts,
      // },
    ],
  },
  {
    name: "Personnel Management",
    path: "/lab/schedule",
    icon: "calendar-alt",
    title: "Personnel scheduling and attendance",
    allowedFor: [
      "Jr. Medical Laboratory Scientist",
      "Medical Laboratory Scientist",
      "Sr. Medical Laboratory Scientist",
      "Chief MLS",
    ],
    children: [
      {
        name: "Attendance",
        title: "Employee daily attendance tracker.",
        path: "/attendances",
        icon: "clock",
        component: Calender,
      },
      {
        name: "Scheduler",
        title: "Employee shift scheduling.",
        path: "/scheduler",
        icon: "calendar-check",
        component: Scheduler,
        allowedFor: ["Sr. Medical Laboratory Scientist", "Chief MLS"],
      },
      {
        name: "Signatories",
        title: "List of section signatories.",
        path: "/signatories",
        icon: "pen",
        component: Heads,
        allowedFor: ["Sr. Medical Laboratory Scientist", "Chief MLS"],
      },
      {
        name: "Mobile Clinic (Quest)",
        title: "Mobile team operations for outreach clinics.",
        path: "/mobile",
        icon: "mobile-alt",
        component: Quest,
      },
      {
        name: "Staff",
        title: "Active laboratory staff directory.",
        path: "/staff",
        icon: "user",
        component: Staffs,
      },
      {
        name: "Applicants",
        title: "Job applicants and interview status.",
        path: "/petitioners",
        icon: "user-plus",
        component: Applicants,
        allowedFor: ["Chief MLS"],
      },
    ],
  },
  {
    name: "Service Management",
    path: "/lab/services",
    icon: "file-medical-alt",
    title: "Service pricing and reference values",
    allowedFor: ["Sr. Medical Laboratory Scientist", "Chief MLS"],
    children: [
      {
        name: "Service Prices",
        icon: "money-bill-wave",
        path: "/pricing",
        title: "Manage cost per test",
        component: Menus,
      },
      {
        name: "Reference Values",
        icon: "sliders-h",
        path: "/reference-values",
        title: "Update test reference ranges",
        component: Services,
      },
    ],
  },
  {
    name: "Catalogs",
    path: "/offers",
    icon: "list",
    title: "Masterlists for services, products, and consumables",
    allowedFor: ["Sr. Medical Laboratory Scientist", "Chief MLS"],
    children: [
      {
        name: "Menus",
        path: "/menus",
        icon: "bars",
        title: "List of services offered",
        component: Menus,
      },
      {
        name: "Services",
        path: "/services",
        icon: "list",
        title: "Service definitions and categories",
        component: Services,
      },
      {
        name: "Products",
        path: "/products",
        icon: "tags",
        title: "Branded products tagged to their generic and suppliers",
        component: Products,
      },
    ],
  },
  {
    name: "Sources",
    path: "/sources",
    icon: "building",
    title: "Outsources & Insources (Loyalty Programs)",
    allowedFor: ["Sr. Medical Laboratory Scientist", "Chief MLS"],
    children: [
      {
        name: "Outsources",
        path: "/outsources",
        icon: "people-carry",
        title: "External Service Providers",
        component: Outsources,
      },
      {
        name: "Affiliated Patient Programs",
        path: "/insources",
        icon: "hand-holding-heart",
        title: "Patient Sources with Discounts or Privileges",
        children: [
          {
            name: "HMO Wellness",
            path: "/wellness",
            icon: "briefcase-medical",
            title: "Partner Companies with HMO Coverage",
            component: Wellness,
          },
          {
            name: "Membership Privileges",
            path: "/membership",
            icon: "id-card-alt",
            title: "Members with Discounted Rates",
            component: Membership,
          },
          {
            name: "Contracted Rates",
            path: "/contract",
            icon: "file-signature",
            title: "Special Pricing Agreements",
            component: Contract,
          },
          {
            name: "Referral",
            path: "/referrals",
            icon: "paper-plane",
            title: "Clinics or Doctors Who Referred Patients",
            component: Referrals,
          },
        ],
      },
      {
        name: "Suppliers",
        path: "/suppliers",
        icon: "boxes",
        title: "Suppliers for Goods & Services",
        component: Suppliers,
      },
      {
        name: "Utilities",
        path: "/utilities",
        icon: "plug",
        title: "Utilities & Support Services",
        component: Utilities,
      },
    ],
  },
  {
    name: "Reports",
    path: "/lab/reports",
    icon: "file-medical",
    title: "Summary and detailed reports",
    allowedFor: ["Sr. Medical Laboratory Scientist", "Chief MLS"],
    children: [
      {
        name: "Daily Summary",
        icon: "calendar-day",
        path: "/daily",
        title: "Daily operations summary",
      },
      {
        name: "Monthly Logs",
        icon: "calendar",
        path: "/monthly",
        title: "Monthly logs and summaries",
      },
      {
        name: "Logbooks",
        path: "/logbooks",
        icon: "book",
        title: "Laboratory logbooks per section",
        children: [
          {
            name: "Chemistry",
            title: "Logbook for chemistry tests.",
            path: "/chemistry",
            icon: "flask",
            component: ChemistryLogbook,
          },
          {
            name: "Hematology",
            title: "Logbook for hematology tests.",
            path: "/hematology",
            icon: "tint",
            component: HematologyLogbook,
          },
          {
            name: "Urinalysis",
            title: "Logbook for urinalysis tests.",
            path: "/urinalysis",
            icon: "vial",
            component: UrinalysisLogbook,
          },
          {
            name: "Fecalysis",
            title: "Logbook for fecalysis tests.",
            path: "/fecalysis",
            icon: "poop",
            component: FecalysisLogbook,
          },
          {
            name: "Serology",
            title: "Logbook for serology tests.",
            path: "/serology",
            icon: "syringe",
            component: SerologyLogbook,
          },
          {
            name: "Electrolyte",
            title: "Logbook for electrolyte tests.",
            path: "/electrolyte",
            icon: "bolt",
            component: ElectrolyteLogbook,
          },
          {
            name: "Miscellaneous",
            title: "Logbook for miscellaneous tests.",
            path: "/miscellaneous",
            icon: "list",
            component: MiscellaneousLogbook,
          },
        ],
      },
    ],
  },
  {
    name: "Working Area",
    path: "/lab/working-area",
    icon: "microscope",
    title: "Access different lab working sections",
    allowedFor: benchStaff,
    component: WorkingArea,
    // children: [
    //   {
    //     name: "Clinical Microscopy",
    //     path: "/lab/working-area/clinical-microscopy",
    //     icon: "vial",
    //     title: "Routine urinalysis, stool exam, etc.",
    //     // component: ClinicalMicroscopy,
    //   },
    //   {
    //     name: "Hematology",
    //     path: "/lab/working-area/hematology",
    //     icon: "tint",
    //     title: "CBC, blood smears, ESR, etc.",
    //   },
    //   {
    //     name: "Clinical Chemistry",
    //     path: "/lab/working-area/clinical-chemistry",
    //     icon: "flask",
    //     title: "Glucose, enzymes, electrolytes, etc.",
    //   },
    //   {
    //     name: "Immunology & Serology",
    //     path: "/lab/working-area/immuno-sero",
    //     icon: "syringe",
    //     title: "Antibody-antigen testing",
    //   },
    //   {
    //     name: "Microbiology",
    //     path: "/lab/working-area/microbiology",
    //     icon: "bug",
    //     title: "Culture and sensitivity, gram stain",
    //   },
    //   {
    //     name: "Blood Banking",
    //     path: "/lab/working-area/blood-bank",
    //     icon: "hand-holding-medical",
    //     title: "Crossmatching and blood typing",
    //   },
    // ],
  },
  {
    name: "Machines",
    path: "/lab/machines",
    icon: "tools",
    title: "Access different lab working sections",
    component: Machines,
  },
  {
    name: "Settings",
    path: "/settings",
    icon: "sliders-h",
    title: "System settings and configuration",
    allowedFor: ["Chief MLS"],
    children: [
      {
        name: "System",
        path: "/system",
        icon: "cogs",
        title: "System settings and configuration",
      },
    ],
  },
];

export default laboratory;
